export default __webpack_public_path__ + "static/media/deposit-inactive.cfd344e7.svg";